export const PRESTIGE4N_PROMO_CODE = 'PRESTIGE4N'

export function isPrestige4nPromo(code?: string | null): boolean {
  return (code ?? '').toUpperCase() === PRESTIGE4N_PROMO_CODE
}
